import { render } from "./DiscountCondition.vue?vue&type=template&id=b920b4be&ts=true"
import script from "./DiscountCondition.vue?vue&type=script&lang=ts"
export * from "./DiscountCondition.vue?vue&type=script&lang=ts"

import "./DiscountCondition.vue?vue&type=style&index=0&id=b920b4be&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__